import { Flow } from '@thive/fddm-types';
import { assertNever } from '@/helpers/utils';
import { ConsolidationFlow } from './types';
import { FddmServiceFactory } from '../canvas/services/Floorplan/FddmServiceFactory';

export function setFlowLoadsPreference(type: Flow['type'], value: [number, ...number[]]) {
  const fddmSvc = FddmServiceFactory.getInstance().createFddmService();
  switch (type) {
    case 'TRANSPORT':
      fddmSvc.setPreference('flow.hourlyOrderCounts/transport', value[0]);
      break;
    case 'CONSOLIDATION_RETRIEVAL':
      fddmSvc.setPreference('flow.hourlyOrderCounts/consolidationRetrieval', value[0]);
      break;
    case 'CONSOLIDATION_STORAGE':
      fddmSvc.setPreference('flow.hourlyOrderCounts/consolidationStorage', value[0]);
      break;
    case 'GOODS_TO_PERSONS':
      fddmSvc.setPreference('flow.hourlyOrderCounts/goodsToPersons', value[0]);
      break;
    case 'EXTERNAL':
      fddmSvc.setPreference('flow.hourlyOrderCounts/external', value[0]);
      break;
    default:
      assertNever(type);
  }
}

export function setFlowLimitPreference(type: Flow['type'], value: number) {
  const fddmSvc = FddmServiceFactory.getInstance().createFddmService();
  switch (type) {
    case 'TRANSPORT':
      fddmSvc.setPreference('flow.vehicleLimit/transport', value);
      break;
    case 'CONSOLIDATION_RETRIEVAL':
      fddmSvc.setPreference('flow.vehicleLimit/consolidationRetrieval', value);
      break;
    case 'CONSOLIDATION_STORAGE':
      fddmSvc.setPreference('flow.vehicleLimit/consolidationStorage', value);
      break;
    case 'GOODS_TO_PERSONS':
      fddmSvc.setPreference('flow.vehicleLimit/goodsToPersons', value);
      break;
    case 'EXTERNAL':
      fddmSvc.setPreference('flow.vehicleLimit/external', value);
      break;
    default:
      assertNever(type);
  }
}

export function setConsolidationAmountPreference(
  type: ConsolidationFlow['type'],
  numConsolidations: number,
) {
  const fddmSvc = FddmServiceFactory.getInstance().createFddmService();
  switch (type) {
    case 'CONSOLIDATION_RETRIEVAL':
      fddmSvc.setPreference(
        'flow.consolidationRetrievalExtension.numConsolidations',
        numConsolidations,
      );
      break;
    case 'CONSOLIDATION_STORAGE':
      fddmSvc.setPreference(
        'flow.consolidationStorageExtension.numConsolidations',
        numConsolidations,
      );
      break;
    default:
      assertNever(type);
  }
}
